import {IIni} from "../_interfaces/IIni";
import {Signal} from "@preact/signals-react";
import {signal} from "@preact/signals-core";

export const s_ini: Signal<(IIni)[]> = signal([]);
